import { InvoicePayload } from '../../types/invoicePayload'

const INVOICE_NUMBER_PLACEHOLDER = '00'

// mostly meant for adjusting the preview data so that it shows the template for the invoices,
// but doesn't imply any specific data in terms of number, dates etc.
export const getModifiedRecurringInvoicePayload = (payload: InvoicePayload): InvoicePayload => {
  const { invoiceNumber } = payload.fields

  return {
    ...payload,
    fields: {
      ...payload.fields,

      ...(invoiceNumber
        ? {
            invoiceNumber: {
              ...invoiceNumber,
              value: INVOICE_NUMBER_PLACEHOLDER,
            },
          }
        : {}),
    },

    ...(payload.invoiceNumber
      ? {
          invoiceNumber: {
            ...payload.invoiceNumber,
            number: 0, // align with the INVOICE_NUMBER_PLACEHOLDER value
          },
        }
      : {}),
  }
}
